<div
  id="MassStabSliderComponent"
  class="card esri-widget animation-on-tool-open"
  #massStabSliderComponentRef
  gisDraggableWidget
  [dragHandle]="dragArea"
>
  <!--- the card header -->
  <div class="card-header" #dragArea>
    <div class="row">
      <div class="col-md-8" translate>
        WIDGET.SCALING.PANEL_HEADING
      </div>
      <div class="col-md-4">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>
  <!-- the panel body -->
  <div class="card-body">
    <div #sliderRef id="masstabSlider" class="-align-center"></div>
  </div>
</div>
